/* eslint-disable no-bitwise */
import { dmEnv } from '@dm/utils';
import dayjs from 'dayjs';
import { Deserialize } from './serialization';
import validate from './validate';

export const isObject = (obj) => Object.prototype.toString.call(obj) === '[object Object]';
// 处理直营app android 手机 6.0及以下系统
export const zaAppScrollCompatible = () => {
  const ua = navigator.userAgent.toLowerCase();
  const match = ua.match(/android\s([0-9.]*)/);
  // @ts-ignore
  const [firstItem = false, version = '0'] = match || [];
  const versions = (version && parseFloat(`${version}`.substring(0, 3))) || 0;
  if (validate.isAndroid() && versions <= 6.3 && dmEnv.isApp()) {
    window.scroll = (x?, y?) => {
      if (x && y) {
        window.scrollTo(x, y);
      } else if (isObject(x)) {
        const { top = 0, bottom = 0 } = x;
        window.scrollTo(x, top || bottom);
      } else {
        window.scrollTo(x || 0, 0);
      }
    };
  }
};
/*
//h5发送消息给小程序
export const h5PostMessageBridgeApplet = (payload?) => {
  let { action = '', data = {} } = payload || {};
  if (action) {
    // wx.miniProgram.navigateBack()
    wx && wx.miniProgram.postMessage && wx.miniProgram.postMessage({ data: { action, data } });
  }
}; */
export const loadJS = (src: string, callback: Function) => {
  interface scriptProps {
    onload: any;
    onreadystatechange?: any;
    src: string;
    readyState?: any;
  }
  const script: scriptProps = document.createElement('script');
  const head: HTMLElement = document.getElementsByTagName('head')[0];
  let loaded = false;

  script.src = src;

  if (typeof callback === 'function') {
    script.onload = script.onreadystatechange = function readystatechange() {
      if (!loaded && (!script.readyState || /loaded|complete/.test(script.readyState))) {
        script.onload = script.onreadystatechange = null;
        loaded = true;
        callback();
      }
    };
  }

  head.appendChild(script as HTMLScriptElement);
};

export function isJSON(str) {
  if (typeof str === 'string') {
    try {
      const obj = JSON.parse(str);
      if (typeof obj === 'object' && obj) {
        return true;
      }
      return false;
    } catch (e) {
      console.log(`error：${str}!!!${e}`);
      return false;
    }
  } else {
    return false;
  }
}

export function hasQueryParams(qs: string, params: { [key: string]: string }[]) {
  if (!qs || !params || !params.length) {
    return false;
  }
  try {
    const qsObj = Deserialize(qs);
    return params.every((param) => {
      const [[k, v]] = Object.entries(param);
      return qsObj[k] === v;
    });
  } catch (e) {
    return false;
  }
}

/**
 * parse date string to Date object.
 * refrence: https://github.com/iamkun/dayjs/blob/dev/src/index.js#L60
 * @param {string} date date string
 * @returns {Date}
 */
export function parseDate(date) {
  if (date instanceof Date) return new Date(date);
  if (typeof date === 'string' && !/Z$/i.test(date)) {
    const REGEX_PARSE = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/;
    const d = date.match(REGEX_PARSE);
    if (d) {
      const m = +d[2] - 1 || 0;
      const ms = (d[7] || '0').substring(0, 3);
      return new Date(+d[1], m, +d[3]
        || 1, +d[4] || 0, +d[5] || 0, +d[6] || 0, +ms);
    }
  }

  return new Date(date); // everything else
}

/**
 * @description 根据最大文字展示数量，截取内容
 * @param Object - { value: string; maxAmount: number }
 */
export function textOverFlowByAmount(
  {
    value,
    maxAmount,
    isInCludeEllipsis = false,
  }:
    {
      value: string;
      maxAmount: number;
      isInCludeEllipsis?: boolean;
    },
): {
      isSlice: boolean;
      ellipsisStr: string;
    } {
  const tmpVal = value || '';
  const sliceStr = tmpVal.slice(0, isInCludeEllipsis ? maxAmount : maxAmount - 3);
  const ellipsisStr = sliceStr.length < tmpVal.length ? `${sliceStr}...` : sliceStr;
  return {
    isSlice: sliceStr.length < tmpVal.length,
    ellipsisStr,
  };
}

/**
 * @description 获取下一个自然日与当前时间的时间差
 * @return diff
 */
export function getDiffTimeToNextDay(): number {
  const currentDate = dayjs();
  const nextDate = dayjs(dayjs().add(1, 'day').format('YYYY-MM-DD'));
  const diff = nextDate.diff(currentDate);
  return diff;
}

/**
 * @description 寻找某个dom节点的父节点（父节点className匹配输入的parentClassName）
 * @param el dom节点
 * @param parentClassName 需要匹配的父节点的className
 * @returns
 */
export function findUpClassName(el, parentClassName) {
  while (el.parentNode) {
    el = el.parentNode;
    if (el.className && el.className.includes(parentClassName)) { return el; }
  }
  return null;
}

/**
 * 表单校验
 * @param formData 表单数据
 * @param rules 表单校验规则
 */
export function validator(formData, rules) {
  const filed = Object.keys(rules);
  return filed.reduce((pre: string[], cur) => {
    const { required, min, max, pattern, formType, customValidate } = rules[cur];
    const value = formData[cur];
    if (required && validate.isEmpty(value)) {
      let action = '填写';
      if (['select', 'checkbox', 'radio'].includes(formType)) {
        action = '选择';
      }
      pre.push(`请${action}${rules[cur].fieldName}`);
    }
    if (min && value && value < min) {
      pre.push(`${rules[cur].fieldName}不能小于${min}`);
    }
    if (max && value && value > max) {
      pre.push(`${rules[cur].fieldName}不能大于${max}`);
    }
    if ((pattern && !pattern.test(value)) || (customValidate && !customValidate(value))) {
      pre.push(rules[cur].errorMsg || `${rules[cur].fieldName}格式不正确`);
    }
    return pre;
  }, []);
}

/**
 * 生成 UUID
 * @returns string
 */
export function generateUUID() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = Math.random() * 16 | 0;
    const v = c === 'x' ? r : ((r & 0x3) | 0x8);
    return v.toString(16);
  }).toUpperCase();
}

/**
 * @description 人工干预触发滚动，保证输入框在视窗中间
 * @param currentInput
 * @param visualHeight
 * @param scrollObj
 */
export function calcScrollTop(currentInput, visualHeight, scrollObj?) {
  scrollObj = scrollObj || window;
  const currentInputTop = currentInput.getBoundingClientRect().top;
  // 已经偏移（滚动）的量
  let yOffset = window.pageYOffset;
  if (scrollObj !== window) {
    yOffset = scrollObj.scrollTop;
  }
  // 不在可视视口中
  // 被软键盘遮住
  if (currentInputTop > visualHeight) {
    scrollObj.scrollTo(0, yOffset + currentInputTop - visualHeight / 2 + currentInput.offsetHeight / 2);
  // 滚上去了可视视口，被视口遮住
  } else if (currentInputTop < 0) {
    scrollObj.scrollTo(0, yOffset - currentInputTop - visualHeight / 2 + currentInput.offsetHeight / 2);
  }
}

const OSSDomain = 'https://za-mall-prd.oss-cn-hzfinance.aliyuncs.com';
const CNDDomain = 'https://assets.zafshealth.com';
/**
 * 将 oss 的 url 替换为 cdn 的 url
 * @param url
 * @returns
 */
export function replaceURLWithCDN(url: string) {
  if (typeof url !== 'string') return url;
  if (url.startsWith(OSSDomain)) {
    return url.replace(OSSDomain, CNDDomain);
  }
  return url;
}
